import { BlogPost } from 'common/hooks/useArticleTemplate'
import { useNavigate } from 'react-router-dom'

const FeaturedArticles = ({ featuredHome }: { featuredHome: BlogPost[] }) => {
  const navigate = useNavigate()

  return (
    <section
      id='featured-articles'
      className='flex flex-col items-center mt-12 px-4 sm:!px-48'
    >
      <div className='w-full flex flex-col gap-2 mb-12'>
        <div className="text-slate-900 sm:text-4xl text-lg font-bold font-['DM_Sans'] tracking-wide">
          Featured articles
        </div>
        <div className='w-full sm:h-2 h-1 bg-gradient-to-r from-cyan-800 to-sky-400' />
      </div>

      {featuredHome.slice(0, 2).map((article) => (
        <div
          key={article.id}
          className='w-full flex flex-row justify-between gap-12 mb-16'
        >
          <div className='flex flex-col gap-4'>
            <div className='text-slate-900 sm:text-2xl text-lg sm:text-center text-left font-bold font-["DM_Sans"]'>
              {article.title}
            </div>
            <div className='text-slate-700 sm:text-lg text-xs font-normal font-["DM_Sans"] leading-normal tracking-wide'>
              {article.summary}
            </div>
            <div
              onClick={() => navigate(`/articles/${article.id}`)}
              className='cursor-pointer mt-2'
            >
              <div className='text-slate-900 sm:text-sm text-xs font-medium font-["DM_Sans"] border-b-[1.4px] border-slate-900 inline-block'>
                Read more
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  )
}

export default FeaturedArticles
